import { useState, createContext } from 'react';
import { useParams } from 'react-router-dom';

type PropertyPreviewParams = {
  propertyId?: string;
  brokerId?: string;
  portfolioFolderId?: string;
};
const PropertyPreviewParamsContext = createContext<{
  params: PropertyPreviewParams;

  setParams: (params: PropertyPreviewParams) => void;
}>({
  params: {},

  setParams: () => null,
});

function PropertyPreviewParamsProvider({
  children,
}: {
  children: JSX.Element;
}) {
  const { id, brokerId } = useParams();
  const [params, setParams] = useState<PropertyPreviewParams>({
    propertyId: id ?? undefined,
    brokerId: brokerId ?? undefined,
  });

  return (
    <PropertyPreviewParamsContext.Provider
      value={{
        params,
        setParams,
      }}
    >
      {children}
    </PropertyPreviewParamsContext.Provider>
  );
}

export { PropertyPreviewParamsContext, PropertyPreviewParamsProvider };
